<template>
  <div v-if="collaborator === null || content === null"></div>
  <v-dialog v-else v-model="value" persistent max-width="500px" scrollable>
    <v-card>
      <v-card-title class="modal_title">
        <div class="circle">
          <v-icon color="error">warning</v-icon>
        </div>
        <span>{{ content.title }}</span>
      </v-card-title>
      <v-card-text>
        <p class="text">{{ content.text }}</p>
      </v-card-text>
      <v-card-actions>
        <v-btn primary flat @click="close" class="modal_button">{{ content.cancel }}</v-btn>
        <v-btn color="primary" @click="submit" class="modal_button">{{ content.ok }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // content recive an object like so {ok:'submit' cancel:'cancel', title:'some tile', text:'some text', isNew:true}
  props: ['value', 'content'],
  data: () => ({
    value: false,
  }),
  methods: {
    submit() {
      this.$emit('update', { showSuccess: true, isOk: true })
      this.closeModal();
    },
    close() {
      if (this.content.isNew) {
        this.$emit('update', { showSuccess: true, isOk: false })
        this.closeModal();
        return;
      }
      this.$emit('update', { showSuccess: false, isOk: false })
      this.closeModal();
    },
    closeModal() {
      this.value = false;
      this.$emit('changed', false)
    }
  },
}
</script>

<style scoped>
/* override css */
::v-deep .v-btn__content {
  text-transform: initial !important;
}

.custom_input_title {
  font-weight: 500;
}

.modal_title {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  padding-top: 20px;
  padding-bottom: 0px;
}

.modal_title span {
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.circle {
  padding: 8px 10px;
  border-radius: 100%;
  background-color: #FEE2E2;
}

.modal_button {
  margin: 0;
  width: 50%;
  border-radius: 8px;
  border: 1px solid #cccc;
  color: #272727;
  text-transform: capitalize;
}

.modal_button:last-of-type {
  width: calc(50% - 10px);
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
}

.text {
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  color: #6B7280;
}
</style>
